export default "__VITE_ASSET__Dohu$GIH__"